import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import classes from './SubscriptionSuccess.module.css';
import { startBookUpgradeConfetti, stopBookUpgradeConfetti } from '../utils/bookUpgradeConfetti';
import { consumeDictionaryPaymentReturn } from '../utils/dictionaryPaymentReturn';

const COPY = {
    de: {
        title: 'Abonnement abgeschlossen!',
        subtitle: 'Sie haben jetzt ein Premium-Konto.',
        line1: 'Ihr Abonnement ist jetzt aktiv.',
        line2: 'Melden Sie sich an und nutzen Sie das digitale Wörterbuch.',
        cta: 'Zum Login',
    },
    en: {
        title: 'Subscription done!',
        subtitle: 'You now have a premium account.',
        line1: 'Your subscription is now active.',
        line2: 'Log in and start using the digital dictionary.',
        cta: 'Go to login',
    },
};

function langKey(language) {
    return String(language || '').toLowerCase() === 'de' ? 'de' : 'en';
}

/**
 * Pantalla tras pago premium exitoso (p. ej. URL de retorno de Saferpay).
 * Ruta: `/subscriptionSuccess`
 */
export default function SubscriptionSuccess({ language }) {
    const t = COPY[langKey(language)];
    const confettiCanvasRef = useRef(null);
    const [celebratePaymentReturn, setCelebratePaymentReturn] = useState(false);

    useEffect(() => {
        if (consumeDictionaryPaymentReturn(language)) {
            setCelebratePaymentReturn(true);
        }
    }, [language]);

    useEffect(() => {
        return () => stopBookUpgradeConfetti();
    }, []);

    useEffect(() => {
        if (!celebratePaymentReturn) return;
        let innerId;
        const outerId = requestAnimationFrame(() => {
            innerId = requestAnimationFrame(() => {
                startBookUpgradeConfetti(confettiCanvasRef.current);
            });
        });
        return () => {
            cancelAnimationFrame(outerId);
            if (innerId != null) cancelAnimationFrame(innerId);
        };
    }, [celebratePaymentReturn]);

    return (
        <div className={classes.shell}>
            <canvas ref={confettiCanvasRef} className={classes.confettiCanvas} aria-hidden />
            <div className={classes.inner}>
                <h1 className={classes.title}>{t.title}</h1>
                <p className={classes.subtitle}>{t.subtitle}</p>

                <div className={classes.iconCircle} aria-hidden>
                    <i className={`icon icon-premium ${classes.iconPremium}`} />
                </div>

                <p className={classes.body}>{t.line1}</p>
                <p className={`${classes.body} ${classes.bodyLast}`}>{t.line2}</p>

                <div className={classes.cta}>
                    <Link to="/login" className={`btn ochre ${classes.ctaLink}`}>
                        {t.cta}
                    </Link>
                </div>
            </div>
        </div>
    );
}
